const APP_MODE_KEY = 'dreamdrums_app_mode';

export function detectAppMode(): void {
  const params = new URLSearchParams(window.location.search);
  if (params.get('source') === 'app') {
    localStorage.setItem(APP_MODE_KEY, 'true');
  }
}

export function isAppMode(): boolean {
  return localStorage.getItem(APP_MODE_KEY) === 'true';
}
